export default "__VITE_ASSET__CBzTfPJ8__ 600w";